import { AxiosRequestConfig, AxiosResponse } from "axios";

export const config = {
    aggregationsUrl: "/lanes/aggregations",
    lanesInfoUrl: "/lanes",
    lanesTempUrl: "/lanes/tempExcursions",
    mapDetailsUrl: "/lanes/map",
    shipmentsDetails: "/shipments",

    laneTripStatisticsUrl: (laneId: string) => `/lane/${laneId}/statistics`,
    laneTemperatureStatisticsUrl: (laneId: string) => `/lane/${laneId}/temperatureStatistics`,
    laneTemperatureProfile: (laneId: string) => `/lane/${laneId}/temperatureProfile`,

    laneRoutesUrl: (laneId: string) => `/lane/${laneId}/routes`,
    laneShipmentsUrl: (laneId: string) => `/lane/${laneId}/shipments`,
    routeAggregationsUrl: (laneId: string) => `/lane/${laneId}/routes/aggregations`,
    routeTempExcursionAggregationsUrl: (laneId: string) => `/lane/${laneId}/routes/tempExcursions`,

    routeShipmentsUrl: (routeId: string) => `/route/${routeId}/shipments`,
    shipmentUrl: (shipmentId: string) => `/shipment/${shipmentId}`,

    modesOfTransportationUrl: "/modesOfTransportation",
    logisticServiceProvidersUrl: `/logisticsServiceProviders`,
    packagingTypesUrl: `/packagingTypes`,
    productsUrl: `/productTypes`,

    /// ////////////////////////////////////////////////////////////////////////////////////

    deliveries: `/deliveries`,
    deliveryDetails: (deliveryId: string) => `/delivery/details/${deliveryId}`,
    deliveryBatchDetails: (batchId: number) => `/batch/${batchId}`,
    deliveryMonitorsTemperature: (deliveryId: string) => `/delivery/${deliveryId}/monitorsTemperatures`,

    /// ////////////////////////////////////////////////////////////////////////////////////

    activeEvents: `/activeEvents`,
    eventDetails: (eventId: number) => `/activeEvent/${eventId}/details`,
    historicalEventDetails: (eventId: number, batchId: number) => `/batch/${batchId}/eventDetails/${eventId}`,
    deviceData: (eventId: number) => `/activeEvent/${eventId}/deviceData`,

    eventBatchStatus: `/eventBatchStatus`,
    closeEvent: (eventId: number) => `/closeEvent/${eventId}`,
    downloadPDF: (eventId: number) => `/activeEvent/${eventId}/summaryPdf`,
    eventSummary: (eventId: number) => `/activeEvent/${eventId}/summary`,

    flows: (batchId: number) => `/batch/${batchId}/flows`,
    assignFlow: `/assignProductFlow`,
    setAssessmentStatus: `/setAssessmentStatus`,

    changeDueDate: (eventId: number) => `activeEvent/${eventId}/changeDueDate`,
    eventPriority: `/eventPriority`,
    eventType: `/eventType`,
    returnToStock: `/setReturnedToStock`,
    resetAllEvents: `/resetAllEvents`,
    resetEvent: (eventId: number) => `/event/${eventId}/reset`,

    reopenEvent: (eventId: number) => `/activeEvent/${eventId}/reOpenEvent`,

    /// ////////////////////////////////////////////////////////////////////////////////////

    users: `/users`,
    userInfo: `/users/self`,
    assignUserToEvent: (eventId: number) => `/activeEvent/${eventId}/assignUser`,

    getUploadPresignedUrl: `/uploadFileUrl`,
    getDownloadPresignedUrl: `/downloadFileUrl`,
    getFormDownloadPresignedUrl: `/downloadFormUrl`,
    confirmUpload: `/confirmFileUpload`,
    deleteEventAttachment: `/deleteEventAttachment`,

    customers: `/customers`,
    allCustomers: `/allCustomers`,
    getCustomer: (id: number) => `/customers/${id}`,
    modules: `/modules`,

    tempUsers: `/allUsers`,

    setQuantity: `/assessment/updateQty`,

    // Groups tab
    globalGroups: `/globalGroups`,
    customerGroups: (id: number) => `/customer/${id}/groups`,
    globalUsers: `/users/global`,
    customerUsers: (id: number) => `/customer/${id}/users`,
    customerModules: (id: number) => `/customer/${id}/modules`,
    addGlobalGroup: `/globalGroups`,
    addCustomerGroup: `/customerGroups`,
};

export const bypassErrorInterceptor = (response: AxiosResponse<any> | undefined, config: AxiosRequestConfig) => {
    const [url, method] = [config.url, config.method];
    console.log({ url, method });
    const urls = ["/users", "/customers", "/customerGroups", "/globalGroups"];
    return urls.includes(url!) && method === "post";
};
